import React from 'react';
import { Card } from 'react-bootstrap';
export default function UnAutorization() {
    return React.createElement(Card, { style: { height: 'calc(100vh - 200px)' } },
        React.createElement(Card.Header, { className: 'bg-danger d-flex' },
            React.createElement("h2", null, "NO ESTA AUTORIZADO PARA ESTAR EN ESTE SITIO")),
        React.createElement(Card.Body, null,
            React.createElement(Card.Img, { style: { marginLeft: '25%', transform: 'translate(-50%);', width: '15rem', height: '15rem' }, width: '15rem', height: '15rem', src: '/logos/stop.svg' })));
}
//# sourceMappingURL=UnAutorization.js.map